
// src/features/auth/state/tenant-state/tenantSelectors.ts

import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/app/store';

export const selectTenantFeatures = createSelector(
  [(state: RootState) => state.tenant.current],
  (tenant) => tenant?.features || []
);

export const selectHasFeature = (feature: string) =>
  createSelector(
    [selectTenantFeatures],
    (features) => features.includes(feature)
  );

export const selectTenantPlan = createSelector(
  [(state: RootState) => state.tenant.current],
  (tenant) => tenant?.plan || 'free'
);

export const selectIsEnterprisePlan = createSelector(
  [selectTenantPlan],
  (plan) => plan === 'enterprise'
);

export const selectTenantSettings = createSelector(
  [(state: RootState) => state.tenant.current],
  (tenant) => tenant?.settings || null
);

export const selectCanInviteUsers = createSelector(
  [(state: RootState) => state.tenant.current],
  (tenant) => {
    if (!tenant) return false;
    // Would need to check current user count against maxUsers
    return true; // Simplified for now
  }
);

